import { useTheme } from '@mui/material';

import type { Node } from '@xyflow/react';

/**
 * Gets the color for a given node based on the theme.
 *
 * @param {Node | undefined} node - The node for which to generate the color.
 * @return {string} The color value for the node.
 */
export function useNodeColor(node: Node | undefined): string {
  const theme = useTheme();

  if (node !== undefined && 'type' in node && node.type !== undefined && node.type in theme.palette.dialplan) {
    return theme.palette.dialplan[node.type as keyof typeof theme.palette.dialplan];
  }
  return theme.palette.dialplan.playback;
}
